import iconCalendarAdd from "assets/images/ic-calendar-add.svg";
import Button from "components/commons/button";
import MonthPicker from "components/commons/monthpicker";
import moment from "moment";

export const SelectPeriod = ({ selectedMonth, onChangeMonth, onSubmit }) => {
    const MIN_YEAR = 2021

    return (
        <div className={"flex flex-col space-y-10 justify-center items-center pt-28"}>
            <img src={iconCalendarAdd} alt="calendar-add" className={"mx-auto w-16"}/>
            <p className="text-neutral-70">Pilih Bulan Periode</p>
            <div className="flex items-center space-x-3">
                <MonthPicker
                    className="w-[330px]"
                    format='YYYY-MM'
                    placeholder="Pilih Bulan"
                    value={selectedMonth}
                    minYear={MIN_YEAR}
                    maxYear={moment().get('year')}
                    onChange={onChangeMonth}
                />
            </div>

            <Button className="w-[330px]" title="Create Employee Productivity" disabled={!selectedMonth} onClick={onSubmit}/>
        </div>
    )
}
